import React, { useState } from 'react';
import { withStyles, SubAccountBalanceView } from 'vopay';
import { Balance } from '@/hooks/useApi/useAccountBalances';
import BalanceDisplayCard from '../BalanceDisplayCard';
import styles from './AccountNode.module.scss';

const classes = withStyles(styles);

interface AccountNodeProps {
  balances: Balance[];
  displayBalance: SubAccountBalanceView;
  accountName: string;
  isBlurred: boolean;
}

const AccountNode: React.FC<AccountNodeProps> = ({ balances, displayBalance, accountName, isBlurred }) => {
  const [selectedBalanceType, setSelectedBalanceType] = useState<SubAccountBalanceView>(
    displayBalance === 'do-not-show-balances' ? 'available-balance' : displayBalance,
  );

  // Convert Balance[] to BalanceItem[] format for BalanceDisplayCard
  const balanceItems = balances.map((balance) => ({
    currency: balance.Currency,
    availableBalance: String(balance.AvailableFunds || 0),
    rollupBalance: String(balance.RollupAvailableBalance || 0),
  }));

  if (displayBalance === 'do-not-show-balances') {
    return (
      <div className={classes('mainAccount', isBlurred && 'blur')}>
        {accountName}
        <div className={classes('overlayBlur')}></div>
      </div>
    );
  }

  return (
    <div className={classes('mainAccount', isBlurred && 'blur')}>
      <div className={classes('accountNameSection')}>{accountName}</div>

      <BalanceDisplayCard
        balances={balanceItems}
        displayBalance={displayBalance}
        selectedBalanceType={selectedBalanceType}
        onBalanceTypeChange={setSelectedBalanceType}
      />

      <div className={classes('overlayBlur')}></div>
    </div>
  );
};

export default AccountNode;
